<template>
    <div class="page">
        <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item 
                    v-for="(item,i) in breadcrumbList"
                    :to="{path:item.path}"
                    :key="i"
                    >{{item.meta.title}}
                </el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script>
export default {
    data() {
        return {
            
        };
    },

    mounted() {
        
    },
    computed:{
        breadcrumbList(){
            let arr=this.$route.matched
            console.log(this.$route)
            // console.log(this.$router)
            arr.map((res)=>{
                if(res.path == ''){res.path = '/'}
            })
			if(this.$route.query.type == 1){
				this.$route.matched[1].path = '/about?type=1',
				this.$route.matched[1].meta.title = "知识与经验"
				if(this.$route.matched[2].path == "/about/detail"){
					this.$route.matched[2].meta.title = "知识与经验详情"
				}
			}
			console.log(this.$route.matched)
            return this.$route.matched
        }
    },
    methods: {
        
    },
};
</script>

<style lang="less" scoped>
.page{
    width: 1200px;
    margin: 0 auto;
    background: #F4F4F4;
    padding-top: 13px;
    
}
</style>


// WEBPACK FOOTER //
// src/components/head_foot/page.vue